import {
  CONTRACTS_LOAD_REQUEST,
  CONTRACTS_LOAD_SUCCESS,
  CONTRACTS_LOAD_FAILURE,
  CONTRACTS_ADD_CONTRACT,
  CONTRACTS_REMOVE_CANDIDATE_PARTY,
  CONTRACTS_REMOVE_CONTRACT
} from '../types/contracts-types';

const initialState = {
  loading: false,
  error: null,
  contracts: [],
  candidate_parties: []
};

function contracts(state = initialState, action: any = null) {
  switch (action.type) {
    case CONTRACTS_LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case CONTRACTS_LOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };

    case CONTRACTS_LOAD_SUCCESS:
      return {
        ...state,
        contracts: action.payload.contracts,
        candidate_parties: action.payload.candidate_parties,
        loading: false,
        error: null
      };

    case CONTRACTS_ADD_CONTRACT:
      return {
        ...state,
        contracts: [action.payload, ...state.contracts]
      };

    case CONTRACTS_REMOVE_CONTRACT:
      return {
        ...state,
        contracts: state.contracts.filter((party: any) => party.id !== action.payload.id)
      };

    case CONTRACTS_REMOVE_CANDIDATE_PARTY:
      return {
        ...state,
        candidate_parties: state.candidate_parties.filter(
          (party: any) => party.id !== action.payload.id
        )
      };

    default:
      return state;
  }
}

export default contracts;
